import { KdfType } from "../../enums/kdfType";

import { BaseResponse } from "./base.response";

export class IdentityTokenResponse extends BaseResponse {
  accessToken: string;
  expiresIn: number;
  refreshToken: string;
  tokenType: string;

  resetMasterPassword: boolean;
  isFirstDevice: boolean;
  encryptedUserKey: string;
  deviceApprovalRequired: boolean;
  privateKey: string;
  key: string;
  twoFactorToken: string;
  kdf: KdfType;
  kdfIterations: number;
  forcePasswordReset: boolean;
  apiUseKeyConnector: boolean;
  keyConnectorUrl: string;
  roleScope: string;
  roleClaim: Record<string, any>;
  subscription: Record<string, any>;

  constructor(response: any) {
    super(response);
    this.accessToken = response.access_token;
    this.expiresIn = response.expires_in;
    this.refreshToken = response.refresh_token;
    this.tokenType = response.token_type;
    this.roleScope = response.scope;
    this.roleClaim = response.claims ?? response.claim;
    // todo @alex manage default subscription
    this.subscription = response.subscription ?? null;

    this.resetMasterPassword = this.getResponseProperty("ResetMasterPassword");
    // TDE: account has no trusted device yet.
    this.isFirstDevice = this.getResponseProperty("IsFirstDevice");
    // TDE: this device's wrapped UserKey, when the backend recognizes it as trusted.
    this.encryptedUserKey = this.getResponseProperty("EncryptedUserKey");
    // TDE: unrecognized device on an account that already has a trusted device.
    this.deviceApprovalRequired = this.getResponseProperty("DeviceApprovalRequired");
    this.privateKey = this.getResponseProperty("PrivateKey");
    this.key = this.getResponseProperty("Key");
    this.twoFactorToken = this.getResponseProperty("TwoFactorToken");
    this.kdf = this.getResponseProperty("Kdf");
    this.kdfIterations = this.getResponseProperty("KdfIterations");
    this.forcePasswordReset = this.getResponseProperty("ForcePasswordReset");
    this.apiUseKeyConnector = this.getResponseProperty("ApiUseKeyConnector");
    this.keyConnectorUrl = this.getResponseProperty("KeyConnectorUrl");
  }
}
